import Role from '@constants/roles';

enum Page {
  ROOT = 'ROOT',
  LOGIN = 'LOGIN',
  BUILDINGS = 'BUILDINGS',
  EXPENSES = 'EXPENSES',
  PROJECTS = 'PROJECTS',
  PROCESS = 'PROCESS',
  CONFIGURE_EXPENSES = 'CONFIGURE_EXPENSES',
  PERMISSIONS = 'PERMISSIONS',
  DASHBOARDS_GOALS = 'DASHBOARDS_GOALS',
  DASHBOARDS_SHARED_EXPENSES = 'DASHBOARDS_SHARED_EXPENSES',
  BUILDINGS_TOTAL = 'BUILDINGS_TOTAL',
  SHARING_DETAIL = 'SHARING_DETAIL',
  ENABLE_ALLOCATION_TYPE = 'ENABLE_ALLOCATION_TYPE',
}

/**
 * Since every page is accessed only if the user owns certain roles,
 * we must define a set of Pages and the roles of every page
 */

export const PAGE_ROLES: Record<Page, Array<string>> = {
  ROOT: [Role.SUPER, Role.ADMIN, Role.CONTROLLERSHIP, Role.PMO, Role.SHARED],
  LOGIN: [Role.SUPER, Role.ADMIN, Role.CONTROLLERSHIP, Role.PMO, Role.SHARED],
  BUILDINGS: [Role.CONTROLLERSHIP, Role.SHARED],
  EXPENSES: [Role.CONTROLLERSHIP],
  PROJECTS: [Role.PMO],
  PROCESS: [Role.CONTROLLERSHIP],
  CONFIGURE_EXPENSES: [Role.CONTROLLERSHIP],
  DASHBOARDS_GOALS: [Role.PMO],
  DASHBOARDS_SHARED_EXPENSES: [Role.CONTROLLERSHIP],
  PERMISSIONS: [Role.SUPER, Role.ADMIN],
  BUILDINGS_TOTAL: [Role.CONTROLLERSHIP, Role.SHARED],
  SHARING_DETAIL: [Role.CONTROLLERSHIP, Role.SHARED],
  ENABLE_ALLOCATION_TYPE: [Role.SUPER, Role.ADMIN],
};

export const PAGE_PATHS: Record<Page, string> = {
  ROOT: '/',
  LOGIN: '/login',
  BUILDINGS: '/buildings',
  EXPENSES: '/expenses',
  PROJECTS: '/projects',
  PROCESS: '/process',
  CONFIGURE_EXPENSES: '/configure-expenses',
  DASHBOARDS_GOALS: '/dashboards-goals',
  DASHBOARDS_SHARED_EXPENSES: '/dashboards-shared-expenses',
  PERMISSIONS: '/permissions',
  BUILDINGS_TOTAL: '/buildings-total',
  SHARING_DETAIL: '/sharing-detail',
  ENABLE_ALLOCATION_TYPE: '/enable-allocation-type',
};

export default Page;
